// extracted by mini-css-extract-plugin
module.exports = {"personalShopperModal":"style_personalShopperModal__JsidW"};